import { HeapMethods } from "@shared/types/global.ts";
import window from "@shared/utils/app-window.ts";

export const useHeap: () => HeapMethods = () => {
  return window.heap;
};
